<template>
  <div class="color-modal-content-desc text-uppercase font-16 row">
    <div class="col-11">
      <div
        class="d-flex justify-content-center heading-2 black font-weight-bold" v-if="getSelectedProduct.styleName != null && getSelectedProduct.styleName != undefined"
      >
        {{ getSelectedProduct.styleName }}
      </div>
      <div class="d-flex justify-content-center  mt-2" v-if="getSelectedProduct.styleNumber != null && getSelectedProduct.styleNumber != undefined">
        {{ $resourceString["myProject.Project.EditPage.Item.ColorPreviewModal.Style.Label"] }} : {{ getSelectedProduct.styleNumber }}
      </div>
      <div class="d-flex justify-content-center black" v-if="getSelectedProduct.productActualSize != null && getSelectedProduct.productActualSize != undefined">
        {{ $resourceString["myProject.Project.EditPage.Item.ColorPreviewModal.Size.Label"] }}: {{ getSelectedProduct.productActualSize }}
      </div>
      <div class="d-flex justify-content-center black mt-1" v-if="color.colorNumber != null && color.colorNumber != undefined">
        {{ $resourceString["myProject.Project.EditPage.Item.ColorPreviewModal.Color.Label"] }}: {{ color.colorName +' '+ color.colorNumber  }}
      </div>
    </div>
    <div class="col-12 " v-if="color.colorVariationLevel && (color.colorVariationLevel.code != null ||  color.colorVariationLevel.description != null)">
      <div class="d-flex justify-content-center  black mt-1">
        {{ $resourceString["myProject.Project.EditPage.Item.ColorPreviewModal.ColorVariationRating.Label"] }}:
        {{
          color.colorVariationLevel.code +
            " - " +
            color.colorVariationLevel.description
        }}
      </div>
    </div>

    <div class="col-sm-12 create-project-button mt-2">
      <button
        type="button"
        class="m-4 btn btn-primary"
        :disabled="OrderSampleEnabled"
        @click="addItemToCart(color.colorNumber)"
      >
      <span class="png-icon png-icon-icons-glyph--ko-my-basket mr-2"></span>
        {{ $resourceString["myProject.Project.EditPage.Item.ColorPreviewModal.AddToBasketSample.Label"] }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    color: Object
  },
  computed: {
    ...mapGetters({
      getSelectedProduct: "contentWizard/getSelectedProduct",
      OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
    })
  },

  created() {
    this.isOrderSampleEnabled();
  },

  methods: {
    ...mapActions({
      isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
    }),
    addItemToCart(item) {
      this.$emit("addItemToCart", item);
    }
  }
};
</script>
